export const formatValueCurrencyBRL = (text) => {

    let val= text??0;
    return val.toLocaleString('pt-br',
        { style: 'currency', currency: 'BRL' })
}
export default formatValueCurrencyBRL;

export const formatValueCurrencyWithoutSymbol= (text) => {
const value = text;

const formattedWithCurrency = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
}).format(value);

// Remove R$ e espaços extras
const formattedWithoutSymbol = formattedWithCurrency.replace(/[^\d,.-]/g, '').trim();

return formattedWithoutSymbol;  
}